<template>
    <div class="card-block">
      <div class="form-group row">
        <div class="col-md-12 pb-2">
          <h5>
            <strong>
              <i class="far fa-user"></i> Informações Pessoais
            </strong>
          </h5>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-8">
          <div class="input-group">
            <strong>DOCUMENTO DE IDENTIFICAÇÃO:&nbsp;</strong>
            {{ objSelected ? objSelected.pessoa.numeroDocumentoIdentidade : '' }}
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-6">
          <div class="input-group">
            <strong>UF: &nbsp;</strong>
            {{ objSelected ? objSelected.pessoa.siglaUFOrgaoExpeditor : '' }}
          </div>
        </div>

        <div class="col-md-6">
          <div class="input-group">
            <strong>Sexo:&nbsp;</strong>
            {{ objSelected && objSelected.pessoa.sexo === 'F' ? 'Feminino' : 'Masculino' }}
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-6">
          <div class="input-group">
            <strong>Orgão emissor:&nbsp;</strong>
            {{ objSelected ? objSelected.pessoa.descricaoOrgaoExpeditor : '' }}
          </div>
        </div>

        <div class="col-md-6">
          <div class="input-group">
            <strong>Naturalidade:&nbsp;</strong>
            {{ objSelected ? objSelected.pessoa.naturalidade : '' }}
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-6">
          <div class="input-group">
            <strong>Estado civil:&nbsp;</strong>
            {{ objSelected ? objSelected.pessoa.estadoCivil : '' }}
          </div>
        </div>

        <div class="col-md-6">
          <div class="input-group">
            <strong>Escolaridade: &nbsp;</strong>
            {{ objSelected ? objSelected.pessoa.escolaridade : '' }}
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
export default {
  name: 'AssociateInfosPF',
  props: {
    objSelected: {
      type: Object,
      required: true
    }
  }
}
</script>

  <style scoped>
  </style>



// WEBPACK FOOTER //
// src/views/private/associate/components/AssociateInfosPF.vue